<script setup>
defineProps({
  times: {
    type: Array,
    default: () => [],
  },
});
</script>

<template>
  <div class="h-28 flex bg-darkOcean-50">
    <div v-for="(time, index) in times" :key="index">
      <div class="column text-3xl h-full flex items-center">
        <p class="w-12 text-center font-normal">
          {{ time }}
        </p>
      </div>
    </div>
  </div>
</template>

<style>
.column {
  width: 90px;
}
</style>
